import * as React from 'react';
import { MenuContext } from '../context/MenuContext';
/**
 * @description
 * 获取方向样式
 */
export default function useDirectionStyle(className, sub = 0) {
    const { mode, rtl, inlineIndent } = React.useContext(MenuContext);
    if (mode !== 'inline') {
        return null;
    }
    const addlen = inlineIndent + ((className === null || className === void 0 ? void 0 : className.includes('item-with-icon')) ? 24 : 0);
    return rtl
        ? { paddingRight: 16 }
        : { paddingLeft: Math.max(sub, 2) + addlen };
}
